import React from 'react'
import { useMedia, useMemo } from 'sb-hooks'

import Text from 'components/_new/typography/Text/Text'

import messages from './messages'


type SelectableRatingLabelProps = {
  value: number
}

const SelectableRatingLabel: React.FunctionComponent<SelectableRatingLabelProps> = ({ value }) => {
  const { isMobile } = useMedia()

  const labelMessage = useMemo(() => {
    if (value && messages.byRating[value]) {
      return messages.byRating[value]
    }

    return isMobile ? messages.tap : messages.click
  }, [ value, isMobile ])

  return (
    <Text
      size="12-16"
      color={Boolean(value) ? 'brand' : 'gray-50'}
      message={labelMessage}
    />
  )
}


export default SelectableRatingLabel
